// src/components/WorkSection.jsx
import React, { useState, useEffect, useMemo } from 'react';
import './workSection.css';
import { IoArrowForwardCircleOutline } from "react-icons/io5";
import { TfiTimer } from 'react-icons/tfi';
import { PiPottedPlantDuotone } from 'react-icons/pi';
import { LuPaintRoller } from "react-icons/lu";
import { BiBuildings } from "react-icons/bi";
import { AiOutlineSafety } from "react-icons/ai";
import { Link } from 'react-router-dom';
import { worksectiondata } from '../../../../json/sections/Home/worksection';

export default function WorkSection() {
  // window width state to detect mobile
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  useEffect(() => {
    const onResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener('resize', onResize);
    return () => window.removeEventListener('resize', onResize);
  }, []);

  const isMobile = windowWidth <= 768;

  const testimonials = [
    {
      title: "THE BEST RESTORATION PARTNER YOU'LL EVER NEED",
      text: `"We first hired HRD for window washing and cleaning for our building but as we spoke with the foreman that they offered various heights services, we kept them for balcony painting and maintenance, and we have scheduled other services for the future, we like all their height work!"`,
      author: 'Rose Walker - The Royals Manager',
    },
    {
      title: 'SUSTAINABILITY',
      text: `"When it comes to Ecological Maintenance, The guys at HRD were really responsible for the care of water and how they reused and recycle materials, and special paints and none of that affected the quality of their work"`,
      author: 'Moses Clark - Manager Pier West',
    },
    {
      title: 'MINIMAL DISRUPTION',
      text: `"I was surprised by how smooth everything went, the tenants were able to continue their normal routines while they were painting the building, everything was signalled and marked and their equipment always organized"`,
      author: 'Leonard Patrick - Strata Manager',
    },
    {
      title: 'KEEPING WELL DOCUMENTED AND INFORMED',
      text: `"I always felt reassured of the worked done with HRD, they always updated me daily and had pictures of places and areas we could never reach, the before and after of those places kept the owners and myself at peace, that also works with guarantee. Thank you guys!"`,
      author: 'Brian Wong - Parkside Strata Manager',
    },
    {
      title: 'FAST RESPONSE',
      text: `"They responded quickly to our maintenance requests, and their team was professional and courteous. We felt secure knowing the job would be done right the first time."`,
      author: 'Kevin Peterson - Building Administrator',
    },
    {
      title: 'PROFESSIONAL CREW',
      text: `"The HRD crew was extremely professional and paid attention to every detail. Their safety protocols are top notch, and the results speak for themselves."`,
      author: 'Susan Lim - Property Manager',
    },
    {
      title: 'QUALITY WORKMANSHIP',
      text: `"Outstanding quality in their work. We noticed a significant improvement in the appearance and safety of our building. Highly recommended."`,
      author: 'Carlos Ramirez - Facilities Director',
    },
    {
      title: 'RELIABLE PARTNER',
      text: `"We've relied on HRD for multiple projects, and they always deliver on time and within budget. Their team is reliable and communicative throughout each project."`,
      author: 'Linda Chen - Operations Lead',
    },
  ];

  // reorder so that the "header" variant comes first on mobile only
  const displayData = useMemo(() => {
    if (!isMobile) return worksectiondata;
    const headerItem = worksectiondata.find(p => p.variant === 'header');
    const others = worksectiondata.filter(p => p.variant !== 'header');
    return headerItem ? [headerItem, ...others] : worksectiondata;
  }, [isMobile]);

  const iconMap = {
    timer: TfiTimer,
    plant: PiPottedPlantDuotone,
    roller: LuPaintRoller,
    build: BiBuildings,
    save: AiOutlineSafety
  };

  useEffect(() => {
    const carouselEl = document.getElementById('testimonialsCarousel');
    if (!carouselEl || !window.bootstrap) return;

    // previene doble inicialización
    let bsCarousel = window.bootstrap.Carousel.getInstance(carouselEl);
    if (!bsCarousel) {
      bsCarousel = new window.bootstrap.Carousel(carouselEl, {
        interval: 5000,
        pause: 'hover',
        ride: 'carousel',
        wrap: true
      });
    }

    // cleanup al desmontar
    return () => bsCarousel.dispose();
  }, []);

  return (
    <section className="work-section">
      <div className="work-banner">
        <div className="work-banner__content">
          <div className="container">
            <div className="row">
              <div className="col-md-6 center">
                <div className='line-height-clss' style={{ letterSpacing: "-1px" }}>
                  <span>Take a Look at</span>
                  <br/>
                  <span>our Work</span>
                </div>
              </div>
              <div className="col-md-6">
                <Link to="/projects"><IoArrowForwardCircleOutline /></Link>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="work-container">
        <div className="container work-grid">
          <div className="row row-rotate">
            {displayData.map((point, idx) => {
              if (point.variant === 'header') {
                return (
                  <div className="col-md-4 my-5" key={idx}>
                    <div className="point">
                      <h2 className="point__subtitle">{point.subtitle}</h2>
                      <h1 className="point__bigtitle line-height-clss">{point.title}</h1>
                    </div>
                  </div>
                );
              }
              const IconComponent = iconMap[point.icon] || TfiTimer;
              return (
                <div className="col-md-4" key={idx}>
                  <div className="point">
                    <div className="row align-items-center">
                      <div className="col-12 col-md-3 text-center text-md-left mb-3 mb-md-0">
                        <div className="point__icon-wrapper">
                          <IconComponent className="point__icon" />
                        </div>
                      </div>
                      <div className="col-12 col-md-9">
                        <h2 className="point__title">{point.title}</h2>
                      </div>
                    </div>
                    <div className="row mt-3">
                      <div className="col-12">
                        <p className="point__text casper-normal">{point.text}</p>
                      </div>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>

      <div
        className="img-fondo"
        style={{
          backgroundImage: `url('/assets/imgs/home/work/fondo.png')`,
        }}
      >
        <div
          className="img-fondo__contenido carousel slide"
          id="testimonialsCarousel"
          data-bs-ride="carousel"
          data-bs-interval="5000"
          data-bs-pause="hover"
        >
          <h1 className="img-fondo__titulo">Testimonials</h1>
          <div className="carousel-inner">
            {testimonials.map((t, idx) => (
              <div
                key={idx}
                className={`carousel-item ${idx === 0 ? 'active' : ''}`}
              >
                <div className="img-fondo__textos">
                  <h4 className="casper-bold">{t.title}</h4>
                  <p className="casper-normal">{t.text}</p>
                  <span>{t.author}</span>
                </div>
              </div>
            ))}
          </div>
          {/* Controles de Bootstrap */}
          <button
            className="carousel-control-prev"
            type="button"
            data-bs-target="#testimonialsCarousel"
            data-bs-slide="prev"
          >
            <span className="carousel-control-prev-icon" aria-hidden="true"></span>
            <span className="visually-hidden">Previous</span>
          </button>
          <button
            className="carousel-control-next"
            type="button"
            data-bs-target="#testimonialsCarousel"
            data-bs-slide="next"
          >
            <span className="carousel-control-next-icon" aria-hidden="true"></span>
            <span className="visually-hidden">Next</span>
          </button>
        </div>

      </div>
    </section>
  );
}
